import React, { useMemo, useRef } from 'react'
import { useScreenClass } from '../ThemeProvider'
import { useIsSSR } from 'utils/isSSR'

import TabsSlide from './TabsSlide'
import { lazyload } from '../../../../../src/utils/lazyload'

const TabsCollapse = lazyload(() => import('./TabsCollapse'))

const Tabs = ({ children }) => {
  const ref = useRef(null)
  const screenClass = useScreenClass(ref)
  const isSSR = useIsSSR()

  const isMobile = useMemo(() => {
    return ['xs', 'sm'].includes(screenClass)
  }, [screenClass])

  if (isSSR) {
    return null
  }

  return (
    <div ref={ref}>
      {isMobile && <TabsCollapse>{children}</TabsCollapse>}
      {!isMobile && <TabsSlide>{children}</TabsSlide>}
    </div>
  )
}

export default Tabs
